import { useEffect, useState } from 'react';
import api from '@/lib/api';
import { type AdminAuditEventsSearchInput } from '../../types';
import CountTextWrapper from '@/routes/Audit/components/Events/CountTextWrapper';
import CountTextPlaceholder from '@/routes/Audit/components/Events/CountTextPlaceholder';

type AdminAuditEventCountProps = {
  searchInput: AdminAuditEventsSearchInput;
  shownAuditEventCount: number;
};

type AuditEventCounts = {
  totalCount: number;
  filteredCount: number;
};

const AdminAuditEventCount = ({
  searchInput,
  shownAuditEventCount,
}: AdminAuditEventCountProps) => {
  const [counts, setCounts] = useState<AuditEventCounts | null>(null);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setCounts(null);

    api
      .post<AuditEventCounts>('admin-audit-events/count', searchInput)
      .then(auditEventCounts => {
        setCounts(auditEventCounts);
      });
  }, [searchInput]);

  if (counts === null) {
    // This placeholder prevents page jumping when the count request completes
    return <CountTextPlaceholder />;
  }

  if (counts.totalCount === counts.filteredCount) {
    return (
      <CountTextWrapper>
        {counts.totalCount} total audit events ({shownAuditEventCount} shown)
      </CountTextWrapper>
    );
  }

  return (
    <CountTextWrapper>
      Search matched {counts.filteredCount} of {counts.totalCount} audit events
      ({shownAuditEventCount} shown)
    </CountTextWrapper>
  );
};

export default AdminAuditEventCount;
